import { useCallback } from 'react';

import { ENVIRONMENT } from '~/constants';

const getAppScheme = () => {
  const isSTGApp = ENVIRONMENT && ['staging', 'development', 'qa'].includes(ENVIRONMENT);
  const env = (() => {
    switch (ENVIRONMENT) {
      case 'staging':
        return 'stage';
      case 'development':
        return 'dev';
      case 'qa':
        return 'qa';
      default:
        return '';
    }
  })();
  const appScheme = isSTGApp ? 'kurlyro-stg' : 'kurlyro';

  return { env, appScheme };
};

/**
 * @description 컬리로 앱을 여는 커스텀훅
 * - dev: kurlyro-stg://kurlyro.kurly.com/app/dev
 * - qa: kurlyro-stg://kurlyro.kurly.com/app/qa
 * - stg: kurlyro-stg://kurlyro.kurly.com/app/stage
 * - prod: kurlyro://kurlyro.kurly.com
 */
export const useOpenKurlyroApp = () => {
  const openKurlyroApp = useCallback(() => {
    const { env, appScheme } = getAppScheme();

    const deepLink = new URL(`${appScheme}://kurlyro.kurly.com${env ? `/app/${env}` : ''}`);

    window.location.href = deepLink.toString();
  }, []);

  return { openKurlyroApp };
};
